module.exports = __webpack_public_path__ + "img/Rectangle_24.fa473b53.png";